module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blog"
  }, [_vm._m(0), _vm._v(" "), _c('footer-main')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper container clearfix"
  }, [_c('div', {
    staticClass: "posts"
  }, [_c('div', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "background-image": "url('static/img/blog/post.jpg')"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("Excepteur sint occaecat cupidatat non proident")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("02.05.2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('p', [_vm._v("Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam\n            rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt\n            explicabo. Nemo enim ipsam\n            voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui\n            ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n            consectetur, adipisci velit,\n            sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut\n            enim ad minima veniam, quis nostrum ")]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Czytaj więcej")])])])]), _vm._v(" "), _c('div', {
    staticClass: "post"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "background-image": "url('static/img/blog/post.jpg')"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("At vero eos et accusamus et iusto")]), _vm._v(" "), _c('div', {
    staticClass: "date"
  }, [_vm._v("02.05.2017")])])]), _vm._v(" "), _c('div', {
    staticClass: "post-text"
  }, [_c('p', [_vm._v("Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam\n            rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt\n            explicabo. Nemo enim ipsam\n            voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui\n            ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet,\n            consectetur, adipisci velit,\n            sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut\n            enim ad minima veniam, quis nostrum ")]), _vm._v(" "), _c('div', {
    staticClass: "read-more"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Czytaj więcej")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "other-posts"
  }, [_c('div', {
    staticClass: "top-text"
  }, [_vm._v("Pozostałe wpisy")]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("25.01.2017")]), _vm._v(" "), _c('p', [_vm._v("Nam libero tempore, cum soluta nobis.")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("25.01.2017")]), _vm._v(" "), _c('p', [_vm._v("Nam libero tempore, cum soluta nobis.")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "dot"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "date"
  }, [_vm._v("25.01.2017")]), _vm._v(" "), _c('p', [_vm._v("Nam libero tempore, cum soluta nobis.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76dbbcf4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Blog.vue
// module id = 302
// module chunks = 0